/* istanbul ignore file */

import type { ChangeEvent, Ref } from 'react';
import React from 'react';
import type { CheckboxWithLabelProps } from '@noths/polaris-client-ribbons-design-system';
import { CheckboxWithLabel } from '@noths/polaris-client-ribbons-design-system';

import { useTracking } from 'src/hooks/useTracking/useTracking';

interface CheckboxProps extends CheckboxWithLabelProps {
  'data-position'?: string;
  'data-section'?: string;
}

export const Checkbox = React.forwardRef((props: CheckboxProps, ref: Ref<HTMLLabelElement>) => {
  const { trackCompleted } = useTracking();
  const { onChange: delegatedOnChange } = props;

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    trackCompleted(event);

    if (typeof delegatedOnChange === 'function') {
      delegatedOnChange(event);
    }
  };

  return <CheckboxWithLabel ref={ref} {...props} onChange={onChange} />;
});
